import { render } from "./ChoiseColumns.vue?vue&type=template&id=c1a654d4"
import script from "./ChoiseColumns.vue?vue&type=script&lang=js"
export * from "./ChoiseColumns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__